import React, { createContext, useState } from "react";

export const StoryboardsContext = createContext(); 

export const StoryboardsProvider = ({ children }) => {
  const [storyboards, setStoryboards] = useState([]);

  return (
    <StoryboardsContext.Provider value={{ storyboards, setStoryboards}}>
      {children} 
    </StoryboardsContext.Provider>
  );
};
